const designIntroColor = (() => {
  const pageDesign = (document.getElementById("pageDesign") != null);
  if (pageDesign) {

    
    gsap.to('#jsGrayscale', {
      filter: 'grayscale(100%)',
    })

    gsap.to('#jsGrayscale', {
      filter: 'grayscale(0%)',
      scrollTrigger: {
        trigger: '#jsGrayscaleTrigger',
        start: 'top top',
      }
    })


  }
})();
export default designIntroColor;